import { storyParagraphKind, tokenizeStoryInline } from "../../lib/editorialStoryFormattingV1.mjs";

// Shared author-preview / frozen-Reader display. React escapes all source text.
export function EditorialStoryFormattedParagraphV1({ text, preview=false, className="", style }) {
  const parsed=storyParagraphKind(text);
  const nodes=tokenizeStoryInline(parsed.body).map((token,i)=>
    token.mark==="bold" ? <strong key={i} className="font-semibold">{token.text}</strong> :
    token.mark==="italic" ? <em key={i}>{token.text}</em> :
    token.mark==="bolditalic" ? <strong key={i} className="font-semibold"><em>{token.text}</em></strong> :
    <span key={i}>{token.text}</span>);
  if(parsed.kind==="heading") return <h2 data-testid="story-formatted-heading"
    className={"font-serif font-medium leading-snug "+(preview?"text-sm":"pt-3 text-[24px] sm:text-[28px]")+" "+className}
    style={style}>{nodes}</h2>;
  if(parsed.kind==="quote") return <blockquote data-testid="story-formatted-quote"
    className={"border-l-2 border-[#8B8756] pl-4 font-serif italic leading-relaxed "+(preview?"text-xs":"my-6 text-[20px] sm:text-[23px]")+" "+className}
    style={style}>{nodes}</blockquote>;
  return <p data-testid="story-formatted-paragraph" className={className} style={style}>{nodes}</p>;
}
